import React, { Fragment, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import LoadingBarGIF from "../assets/loading-bar 1.gif";
const ErrorDisplay = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleError = (event) => {
      // Check if the error event is a console error
      if (event.error) {
        setError(event.error.message); // Extract error message
      }
    };

    // Add event listener to capture console errors
    window.addEventListener("error", handleError);

    return () => {
      // Clean up event listener when component unmounts
      window.removeEventListener("error", handleError);
    };
  }, []);

  return (
    <div>
      {error && (
        <div style={{ color: "red", border: "1px solid red", padding: "10px" }}>
          Error: {error}
        </div>
      )}
    </div>
  );
};

const MainLayout = (props) => {


  return (
    <div>
      {props ? (
        <Fragment>
          <div className="main">
            <div className={""}>{props?.component}</div>
          </div>
        </Fragment>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "100vh",
            alignItems: "center",
            background: "#000",
          }}
        >
          {/* <Spinner
            animation="border"
            role="status"
            style={{ width: "100px", height: "100px" }}
            variant="secondary"
            size="lg"
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner> */}
          <img src={LoadingBarGIF} />
        </div>
      )}
    </div>
  );
};

export default MainLayout;
